import React, { useEffect, useState } from 'react';
import {
  AZN,
  Bitcoin,
  Ethereum,
  FinanceLogo,
  List,
  AED,
  AUD,
  BRL,
  BYN,
  CHF,
  CNY,
  EGP,
  EUR,
  GBP,
  HKD,
  HUF,
  INR,
  JPY,
  KRW,
  KZT,
  RUB,
  SGD,
  TRY,
  VND,
  ZAR,
  AMD,
  GEL,
  IDR,
  IRR,
  KGS,
  MUR,
  MDL,
  QAR,
  TMT,
  RSD,
  TJS,
  UZS,
  KES,
  RWF,
  TZS,
  UGX,
  USD,
  Asset,
} from 'IMAGE';
import './_magmaBalanceCard.less';
// import getSymbolFromCurrency from 'currency-symbol-map';
import PropTypes from 'prop-types';
import Spinner from '@atoms/spinner';
import { Modal } from 'antd';

const MagmaBalanceCard = ({ balanceMagma }) => {
  const [showModal, setShowModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [destroyOnClose, setDestroyOnClose] = useState(true);

  useEffect(() => {
    if (balanceMagma) {
      const count = Object.keys(balanceMagma).length;
      setShowModal(count > 4);
    }
  }, [balanceMagma]);

  const isLoaded = !balanceMagma;

  const iconArray = [
    { code: 'USD', icon: USD },
    { code: 'USDT', icon: USD },
    { code: 'BTC', icon: Bitcoin },
    { code: 'ETH', icon: Ethereum },
    { code: 'EUR', icon: EUR },
    { code: 'JPY', icon: JPY },
    { code: 'AED', icon: AED },
    { code: 'GBP', icon: GBP },
    { code: 'MUR', icon: MUR },
    { code: 'AUD', icon: AUD },
    { code: 'AZN', icon: AZN },
    { code: 'AED', icon: AED },
    { code: 'AUD', icon: AUD },
    { code: 'BRL', icon: BRL },
    { code: 'BYN', icon: BYN },
    { code: 'CHF', icon: CHF },
    { code: 'CNY', icon: CNY },
    { code: 'EGP', icon: EGP },
    { code: 'EUR', icon: EUR },
    { code: 'GBP', icon: GBP },
    { code: 'HKD', icon: HKD },
    { code: 'HUF', icon: HUF },
    { code: 'INR', icon: INR },
    { code: 'JPY', icon: JPY },
    { code: 'KRW', icon: KRW },
    { code: 'KZT', icon: KZT },
    { code: 'RUB', icon: RUB },
    { code: 'SGD', icon: SGD },
    { code: 'TRY', icon: TRY },
    { code: 'VND', icon: VND },
    { code: 'ZAR', icon: ZAR },
    { code: 'AMD', icon: AMD },
    { code: 'GEL', icon: GEL },
    { code: 'IDR', icon: IDR },
    { code: 'IRR', icon: IRR },
    { code: 'KGS', icon: KGS },
    { code: 'MUR', icon: MUR },
    { code: 'MDL', icon: MDL },
    { code: 'QAR', icon: QAR },
    { code: 'TMT', icon: TMT },
    { code: 'RSD', icon: RSD },
    { code: 'TJS', icon: TJS },
    { code: 'UZS', icon: UZS },
    { code: 'KES', icon: KES },
    { code: 'RWF', icon: RWF },
    { code: 'TZS', icon: TZS },
    { code: 'UGX', icon: UGX },
    { code: 'AAPL', icon: Asset },
    { code: 'GOOG', icon: Asset },
  ];

  const toggleModal = (visible = !visible, destroyOnClose = true) => {
    setVisible(visible);
    setDestroyOnClose(destroyOnClose);
  };

  const formatNumber = (value) => {
    const amount = Number(value).toFixed(2);
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);
  };

  const modalTitle = (
    <div className='fiat-card-modal__header'>
      <div className='fiat-card-modal__brand'>
        <FinanceLogo width={40} height={40} />
        <div className='fiat-card-modal__brand-text'>
          <div className='fiat-card-modal__brand-title'>MAGMA Finance</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className='fiat-card'>
      <div className='fiat-card__header'>
        <div className='fiat-card__brand'>
          <FinanceLogo width={40} height={40} />
          <div className='fiat-card__brand-text'>
            <div className='fiat-card__brand-title'>MAGMA Finance</div>
          </div>
        </div>

        {/*<div className='fiat-card__actions'>*/}
        {/*  <div className='badge'>*/}
        {/*    <span className='icon-mail' />*/}
        {/*    <span className='badge__text'>+2</span>*/}
        {/*  </div>*/}
        {/*  <div className='icon-chevron' />*/}
        {/*</div>*/}
      </div>

      {balanceMagma && (
        <div className='fiat-card__main'>
          <ul className='fiat-card__list'>
            {Object.entries(balanceMagma).map(([key, value]) => {
              const IconComponent = iconArray.find((item) => item.code === key)?.icon;
              return (
                <li key={key} className='fiat-card__row'>
                  <div className='fiat-card__left'>
                    {IconComponent && <IconComponent width={14} height={14} />}
                    <span className='fiat-card__ccy'>{key}</span>
                  </div>
                  <div className='fiat-card__amount'>
                    {/*{getSymbolFromCurrency(key)}*/}
                    {formatNumber(value.balance)}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      )}

      {Array.isArray(balanceMagma) && balanceMagma.length === 0 && (
        <div className='fiat-card__main'>
          <div>To activate the wallet, please contact your personal manager.</div>
        </div>
      )}

      {showModal && (
        <div className='fiat-card__modal-label' onClick={() => toggleModal(true)}>
          <List /> <span className='text'>ALL CURRENCIES</span>
        </div>
      )}

      <Modal
        visible={visible}
        destroyOnClose={destroyOnClose}
        maskClosable={true}
        title={modalTitle}
        footer={null}
        onCancel={() => toggleModal(false)}
      >
        <div className='fiat-card-modal'>
          {balanceMagma && (
            <div className='fiat-card__main'>
              <ul className='fiat-card__list'>
                {Object.entries(balanceMagma).map(([key, value]) => {
                  const IconComponent = iconArray.find((item) => item.code === key)?.icon;
                  return (
                    <li key={key} className='fiat-card__row'>
                      <div className='fiat-card__left'>
                        {IconComponent && <IconComponent width={14} height={14} />}
                        <span className='fiat-card__ccy'>{key}</span>
                      </div>
                      <div className='fiat-card__amount'> {formatNumber(value.balance)}</div>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
      </Modal>

      {isLoaded && <Spinner />}
    </div>
  );
};

export default MagmaBalanceCard;

MagmaBalanceCard.propTypes = {
  balanceMagma: PropTypes.object,
};
